import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Maintenance from '../functions/logic/Maintenance';
import Spiner from './Spiner';
import { useSnackbar } from 'notistack';

import '../scss/_MediaUploader.scss';

export default function ImgModal(props) {
  const [spiner, setSpiner] = useState(false);
  const [media, setMedia] = useState([]);
  const [error, setError] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const userToken = localStorage.getItem('userToken');

  useEffect(() => {
    getMedia();
  }, []);

  const getMedia = async () => {


    const response = await Maintenance.getMediaLogic(userToken, props.moduleId, props.productId);
    if (!response.error) {
      setMedia(response["responseTableMapper"]);
    } else {
      enqueueSnackbar(response.message, {
        variant: response.variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      });
    }

  }

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));

  const handleMediaChange = (e) => {
    const files = Array.from(e.target.files);
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'video/webm', 'video/ogg'];
    const newMedia = [];
    let validationError = '';

    files.forEach((file) => {
      if (validTypes.includes(file.type)) {
        const mediaURL = URL.createObjectURL(file);

        if (file.type.startsWith('video')) {
          const videoElement = document.createElement('video');
          videoElement.onloadedmetadata = () => {
            if (videoElement.duration > 60) {
              validationError = 'Cada video debe durar menos de 1 minuto.';
              URL.revokeObjectURL(mediaURL);
            } else {
              newMedia.push({
                file,
                url: mediaURL,
                type: 'video',
              });
              setMedia((prevMedia) => [...prevMedia, ...newMedia]);
              setError('');
            }
          };
          videoElement.src = mediaURL;
        } else {
          newMedia.push({
            file,
            url: mediaURL,
            type: 'image',
          });
          setMedia((prevMedia) => [...prevMedia, ...newMedia]);
          setError('');
        }
      } else {
        validationError = 'Solo se permiten archivos de imagen JPEG, PNG, GIF y videos MP4, WEBM o OGG.';
      }
    });

    //if (media.length + newMedia.length > 2) {
    // validationError = 'No puedes subir más de 2 medios.';
    //}

    setError(validationError);
  };

  const handleRemoveMedia = async (index) => {
    const newMedia = [...media];
    const removedMedia = newMedia[index];

    if (removedMedia.id) {
      // Llamar al método API para eliminar la media existente por su ID
      /*const response = await deleteMediaById(removedMedia.id); // Suponiendo que deleteMediaById devuelve una promesa

      if (response.success) {
        newMedia.splice(index, 1); // Eliminar la media del array localmente
      } else {
        // Manejar errores o mostrar mensajes de error si la eliminación falla
        enqueueSnackbar('Error al eliminar la media.', { variant: 'error' });
        return;
      }*/
    } else {
      // Si no tiene 'id', es un media nuevo que solo existe en el navegador
      if (removedMedia.url.startsWith('blob:')) {
        URL.revokeObjectURL(removedMedia.url);
      }
      newMedia.splice(index, 1); // Eliminar la media del array localmente
    }

    setMedia(newMedia); // Actualizar el estado de media
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (media.length === 0) {
      enqueueSnackbar('Por favor, ingrese al menos una imagen.', {
        variant: 'warning',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      });
      return;
    }

    // Filtrar solo los nuevos medios que no tienen ID
    const newMedia = media.filter(item => !item.id);

    if (newMedia.length === 0) {
      enqueueSnackbar('No hay nuevos medios para guardar.', {
        variant: 'info',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      });
      return;
    }

    const formData = new FormData();
    newMedia.forEach((item, index) => {
      formData.append(`media${index}`, item.file);
    });

    const response = await Maintenance.saveMediaLogic(userToken, props.moduleId, props.productId, newMedia);
    if (!response.error) {
      setSpiner(false);
      enqueueSnackbar(response.message, {
        variant: response.variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      });
      setTimeout(function () {
        //localStorage.clear();
        //window.location.reload();
        getMedia();
      }, global.DELAY);
    } else {
      setSpiner(false);
      enqueueSnackbar(response.message, {
        variant: "error",
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      });
    }
  };


  return (
    <>
      <Spiner opt={spiner} />
      <BootstrapDialog
        onClose={props.handleCloseModal}
        aria-labelledby="customized-dialog-title"
        open={Boolean(props.isOpen)}
        fullWidth={true}
        maxWidth={props.maxWidth ? 'lg' : 'sm'}
      >
        <DialogTitle id="customized-dialog-title">
          {props.header}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.handleCloseModal}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <form action="/" method="POST" onSubmit={(e) => { handleSubmit(e) }}>
          <DialogContent dividers>
            <div className="media-uploader">
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <label htmlFor="media-input" className="upload-button" style={{ marginRight: '8px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}>
                  Subir Media
                </label>
                <input
                  id="media-input"
                  type="file"
                  accept="image/*,video/*"
                  multiple
                  onChange={handleMediaChange}
                  style={{ display: 'none' }}
                />
                <Button type="submit" variant="contained" color="primary" style={{ marginLeft: '8px', height: '36px' }}>
                  Guardar
                </Button>
              </div>
              {error && <p className="error-message">{error}</p>}
              <div className="media-preview-container">
                {media.map((item, index) => (
                  <div key={index} className="media-preview">
                    {item.type === 'video' ? (
                      <video src={item.url} controls className="preview-video"></video>
                    ) : (
                      <img src={item.url} alt="preview" className="preview-image" />
                    )}
                    <button onClick={() => handleRemoveMedia(index)} className="remove-button">
                      X
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </DialogContent>
        </form>
      </BootstrapDialog>
    </>
  );
}
